<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-card>
            <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                <v-flex lg6 md6 sm12>
                    <h-currency-input v-model="configuration.Currency" label="Tỷ giá CNY" :decimal="0" class="input-group--focused"></h-currency-input>
                </v-flex>
                <v-flex lg6 md6 sm12>
                    <h-currency-input label="Cước vận chuyển nội địa (tối thiểu)" v-model="configuration.MinDomesticTransportFee" :decimal="0" class="input-group--focused"></h-currency-input>
                </v-flex>
                <v-flex lg4 md4 sm12>
                    <h-currency-input label="Phí cân kuaidi" v-model="configuration.KuaidiWeightPrice" :decimal="0" class="input-group--focused"></h-currency-input>
                </v-flex>
                <v-flex lg4 md4 sm12>
                    <h-currency-input label="Phí cân lô" v-model="configuration.ShipmentWeightPrice" :decimal="0" class="input-group--focused"></h-currency-input>
                </v-flex>
                <v-flex lg4 md4 sm12>
                    <h-currency-input label="Phí khối lô" v-model="configuration.ShipmentVolumePrice" :decimal="0" class="input-group--focused"></h-currency-input>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-text-field v-model="configuration.ChinaStoreAddress" label="Địa chỉ kho Trung Quốc" class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-textarea v-model="configuration.MessageContent" rows="8" label="Thông báo khách hàng" class="input-group--focused"></v-textarea>
                </v-flex>

                <!-- Cấu hình mã QR thanh toán -->
                <v-flex lg12 md12 sm12>
                    <v-divider class="my-3"></v-divider>
                    <div class="subheading font-weight-bold mb-2">Ảnh mã QR thanh toán (Phiếu đề nghị thanh toán)</div>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <input
                        type="file"
                        ref="qrFileInput"
                        accept="image/*"
                        style="display: none;"
                        @change="handleFileInputChange"
                    />
                    <div class="d-flex flex-wrap align-start">
                        <!-- Khung ảnh QR -->
                        <div class="mr-4 mb-3 d-flex flex-column align-center">
                            <!-- Khi CHƯA có ảnh -->
                            <div 
                                v-if="!configuration.PaymentQrImage"
                                class="qr-upload-box qr-empty-box d-flex flex-column align-center justify-center"
                                @click="triggerUpload"
                            >
                                <v-icon size="44" color="primary">mdi-cloud-upload-outline</v-icon>
                                <div class="caption font-weight-medium mt-2 grey--text text--darken-2">Chưa có ảnh mã QR</div>
                                <v-btn 
                                    small 
                                    color="primary" 
                                    class="mt-2 text-capitalize elevation-0"
                                    :loading="uploadingQrImage"
                                    @click.stop="triggerUpload"
                                >
                                    <v-icon small left>mdi-upload</v-icon> Tải ảnh lên
                                </v-btn>
                            </div>

                            <!-- Khi ĐÃ CÓ ảnh -->
                            <div 
                                v-else
                                class="qr-upload-box qr-image-box"
                            >
                                <v-btn
                                    fab
                                    x-small
                                    color="error"
                                    class="qr-delete-btn elevation-2"
                                    title="Xóa ảnh mã QR"
                                    @click.stop="removeQrImage"
                                >
                                    <v-icon small>mdi-close</v-icon>
                                </v-btn>
                                <v-img 
                                    :src="configuration.PaymentQrImage" 
                                    alt="Mã QR thanh toán"
                                    width="150"
                                    height="150"
                                    max-width="150"
                                    max-height="150"
                                    contain
                                    class="qr-image-preview"
                                ></v-img>
                            </div>

                            <!-- Nút đổi ảnh khi đã có ảnh -->
                            <v-btn 
                                v-if="configuration.PaymentQrImage"
                                text 
                                x-small 
                                color="primary" 
                                class="mt-2 text-capitalize"
                                :loading="uploadingQrImage"
                                @click="triggerUpload"
                            >
                                <v-icon x-small left>mdi-camera-retake-outline</v-icon> Đổi ảnh khác
                            </v-btn>
                        </div>

                        <!-- Thông tin và tùy chọn đường dẫn -->
                        <div style="flex: 1; min-width: 280px;" class="mb-3">
                            <div class="mb-2">
                                <span v-if="configuration.PaymentQrImage" class="green--text text--darken-2 font-weight-medium body-2">
                                    <v-icon small color="success">mdi-check-circle</v-icon> Đang sử dụng ảnh QR tùy chỉnh
                                </span>
                                <span v-else class="grey--text text--darken-1 body-2">
                                    <v-icon small color="grey">mdi-information</v-icon> Đang dùng ảnh QR mặc định hệ thống (/static/tcb-9036543710011-qr.png)
                                </span>
                            </div>
                            <div class="caption grey--text text--darken-1 mb-3">
                                Mã QR này sẽ hiển thị ở góc trên bên phải của <strong>Phiếu đề nghị thanh toán</strong> để khách hàng quét thanh toán. Khuyến nghị ảnh vuông, định dạng PNG/JPG rõ nét.
                            </div>
                            <v-text-field
                                v-model="configuration.PaymentQrImage"
                                label="Đường dẫn ảnh mã QR (URL)"
                                class="input-group--focused"
                                placeholder="Dán link ảnh hoặc tải ảnh lên ở khung bên cạnh"
                                clearable
                                outlined
                                dense
                                hide-details="auto"
                            ></v-text-field>
                        </div>
                    </div>
                </v-flex>
            </v-layout>

            <v-card-actions class="pa-3">
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="saveData" :loading="loading">
                    <v-icon left>save</v-icon> Lưu cấu hình
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</div>
</template>

<script>
import {
    mapState
} from "vuex";
import fileUploadService from "@/services/fileUploadService";
import { sendSuccessNotice, sendErrorNotice } from "@/commons/utils";

export default {
    data() {
        return {
            qrImageFile: null,
            uploadingQrImage: false,
        };
    },
    computed: {
        ...mapState({
            loading: state => state.configuration.loading,
            configuration: state => state.configuration.selected
        })
    },
    methods: {
        refreshData() {
            this.$store.dispatch("configuration/getDetail", 1);
        },
        saveData() {
            this.$store.dispatch("configuration/setDetail", {
                data: this.configuration,
                id: this.configuration.ID
            });
        },
        triggerUpload() {
            if (this.$refs.qrFileInput) {
                this.$refs.qrFileInput.click();
            }
        },
        handleFileInputChange(e) {
            const files = e.target.files;
            if (files && files.length > 0) {
                this.onQrImageChange(files[0]);
            }
            e.target.value = '';
        },
        async onQrImageChange(file) {
            if (!file) return;
            const validation = fileUploadService.validateFile(file, ['jpg', 'jpeg', 'png', 'gif'], 5);
            if (!validation.valid) {
                sendErrorNotice(validation.message);
                this.qrImageFile = null;
                return;
            }
            this.uploadingQrImage = true;
            try {
                const result = await fileUploadService.uploadSingleFile(file, 'qr');
                if (result.success) {
                    this.$set(this.configuration, 'PaymentQrImage', result.data.url);
                    sendSuccessNotice('Tải lên ảnh mã QR thành công. Hãy bấm Lưu cấu hình.');
                } else {
                    sendErrorNotice(result.message);
                }
            } catch (error) {
                sendErrorNotice('Lỗi upload file: ' + (error.message || error));
            } finally {
                this.uploadingQrImage = false;
            }
        },
        removeQrImage() {
            this.qrImageFile = null;
            this.$set(this.configuration, 'PaymentQrImage', '');
            sendSuccessNotice('Đã bỏ ảnh QR tùy chỉnh. Hãy bấm Lưu cấu hình để áp dụng.');
        }
    },
    mounted() {
        this.refreshData();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
        if (this.$route.query.uid && this.$route.query.uid !== '') {
            this.configuration.UID = Number(this.$route.query.uid);
        }
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    },
};
</script>

<style scoped>
.qr-upload-box {
    width: 170px;
    height: 170px;
    max-width: 170px;
    max-height: 170px;
    border-radius: 12px;
    position: relative;
    box-sizing: border-box;
    transition: all 0.25s ease-in-out;
    overflow: hidden;
}

.qr-empty-box {
    border: 2px dashed #90caf9;
    background-color: #f8fafc;
    cursor: pointer;
    padding: 16px;
    text-align: center;
}

.qr-empty-box:hover {
    border-color: #1976d2;
    background-color: #eef5fc;
}

.qr-image-box {
    border: 1px solid #e0e0e0;
    background-color: #ffffff;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.qr-image-preview {
    width: 150px !important;
    height: 150px !important;
    max-width: 150px !important;
    max-height: 150px !important;
}

.qr-delete-btn {
    position: absolute !important;
    top: 6px !important;
    right: 6px !important;
    z-index: 10;
    width: 24px !important;
    height: 24px !important;
}
</style>